import React from 'react';
import { Box, Typography } from '@mui/material';

export const PublicCatalogLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          py: 2,
          px: 3,
          bgcolor: 'background.paper',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Bankivo Assist
        </Typography>
      </Box>
      <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>{children}</Box>
    </Box>
  );
};
